import { addScalarClassesToHeadless } from "./add-scalar-classes.js";
export { addScalarClassesToHeadless };
